__turbopack_context__.v({
  "coinBody": "DoubleCoins-module-scss-module__7Yc78a__coinBody",
  "coinBodyLeft": "DoubleCoins-module-scss-module__7Yc78a__coinBodyLeft",
  "coinBodyRight": "DoubleCoins-module-scss-module__7Yc78a__coinBodyRight",
  "coinContent": "DoubleCoins-module-scss-module__7Yc78a__coinContent",
  "coinDeco": "DoubleCoins-module-scss-module__7Yc78a__coinDeco",
  "coinDeco1": "DoubleCoins-module-scss-module__7Yc78a__coinDeco1",
  "coinDeco10": "DoubleCoins-module-scss-module__7Yc78a__coinDeco10",
  "coinDeco11": "DoubleCoins-module-scss-module__7Yc78a__coinDeco11",
  "coinDeco12": "DoubleCoins-module-scss-module__7Yc78a__coinDeco12",
  "coinDeco2": "DoubleCoins-module-scss-module__7Yc78a__coinDeco2",
  "coinDeco3": "DoubleCoins-module-scss-module__7Yc78a__coinDeco3",
  "coinDeco4": "DoubleCoins-module-scss-module__7Yc78a__coinDeco4",
  "coinDeco5": "DoubleCoins-module-scss-module__7Yc78a__coinDeco5",
  "coinDeco6": "DoubleCoins-module-scss-module__7Yc78a__coinDeco6",
  "coinDeco7": "DoubleCoins-module-scss-module__7Yc78a__coinDeco7",
  "coinDeco8": "DoubleCoins-module-scss-module__7Yc78a__coinDeco8",
  "coinDeco9": "DoubleCoins-module-scss-module__7Yc78a__coinDeco9",
});
